import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import ColorPicker from "./ColorPicker";
import { CREATIVE_ASSET_TYPES, CREATIVE_NAMES, MOBILE_FOOTER_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import BaseCreativeControls from "./BaseCreativeControls";
import VideoAssetCreativeType from "./VideoAssetCreativeType";

const CREATIVE_TYPE = CREATIVE_NAMES.MOBILE_FOOTER;

export default function MobileFooter({
    displayCreativeUrl,
    videoCreativeUrl,
    wording,
    expandedWording,
    ctaWording,
    ctaTextColor,
    ctaBackgroundColor,
    handleChange,
    currentCustomer,
    impressionTag,
    clickTag,
    adServingType,
    videoCreativeType,
    vastUrl,
    vastDuration
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <AssetInputOrUploadSection
                    inputValue={displayCreativeUrl}
                    inputLabel="Creative banner (4:3 ratio image)"
                    inputName={MOBILE_FOOTER_AD_FIELDS.displayCreativeUrl}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <VideoAssetCreativeType
                    dropdownLabel={"Video Creative Type"}
                    types={CREATIVE_ASSET_TYPES}
                    videoCreativeTypePropertyName={MOBILE_FOOTER_AD_FIELDS.videoCreativeType}
                    videoCreativeType={videoCreativeType}
                    handleChange={(...args) => {
                        console.log({args})
                        handleChange(...args)
                    }}
                    CREATIVE_TYPE={CREATIVE_TYPE}
                    currentCustomer={currentCustomer}
                    videoUrlInputLabel={"Video URL"}
                    videoUrlInputName={MOBILE_FOOTER_AD_FIELDS.videoCreativeUrl}
                    videoUrl={videoCreativeUrl}
                    vastInputName={MOBILE_FOOTER_AD_FIELDS.vastUrl}
                    vastUrl={vastUrl}
                    vastDurationInputName={MOBILE_FOOTER_AD_FIELDS.vastDuration}
                    vastDuration={vastDuration}
                />
                <InputTextSection
                    label="Swipe-up message (optional)"
                    name={MOBILE_FOOTER_AD_FIELDS.wording}
                    value={wording}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label="Swipe-down message (optional)"
                    name={MOBILE_FOOTER_AD_FIELDS.expandedWording}
                    value={expandedWording}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label="CTA text (optional)"
                    name={MOBILE_FOOTER_AD_FIELDS.ctaWording}
                    value={ctaWording}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
                <ColorPicker
                    label="CTA text color (optional)"
                    name={MOBILE_FOOTER_AD_FIELDS.ctaTextColor}
                    value={ctaTextColor}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
                <ColorPicker
                    label="CTA background color (optional)"
                    name={MOBILE_FOOTER_AD_FIELDS.ctaBackgroundColor}
                    value={ctaBackgroundColor}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                />
            </BaseCreativeControls>

        </>
    );
}
